import { FC, useMemo, useContext, useState, useEffect, useRef } from 'react';
import { Button, Typography, Modal, Form } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import copy from 'copy-to-clipboard';
import { getCookie } from '@lhb/cache';
import IconFont from '@/common/components/IconFont';
import { getShareId } from '@/common/api/common';
import { DrawerDataProps, getRadiusNameBySearchTypeAndValue, getSearchTypeNameByValue, getTitleSearchTypeNameByValue, SpotTypeEnum } from '../../../../ts-config';
import UserInfoContext from '@/layout/context';
import ReportLogo from '@/common/components/business/AreaDetailDrawer/components/ReportLogo';
import { bigdataAction, } from '@/common/utils/bigdata';
import { downloadFile, isNotEmptyAny, queryObjectToString } from '@lhb/func';
import { getSiteModelList } from '@/common/api/networkplan';
import { ARE_AREPORT_CONTAINER_CLASS, AreaReportModule, ChildreClass } from '@/views/pdf/pages/areareport/ts-config';
import { exportModelClusterPDFAsync } from '@/common/api/siteselectionmap';
import { usePageTitle } from '@/common/hook/usePageTitle';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import { uploadPipeline, editEvaluationTitle } from '@/common/api/spotevaluation';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';

const { Text } = Typography;

/**
 * @Description 商圈详情头部部分
 */
const Top: FC<{
  detail: any;
  drawerData: DrawerDataProps;
  tenantId: string;
  configSwitch?: boolean;
  // isSemirModel: boolean;
  getPDFStatus?: any;
  pdfDataStatus?: any;
  /** 默认是围栏内，也可以是radius数字 */
  rangeSelectValue?: string | number;
  shareId?: string;
  waterText?: string;
  uploadPipelineStatus?: number;
  getUploadPipelineStatus?: any;
  isStartAnalyseOfAI?: boolean;
  setIsStartAnalyseOfAI?: any;
  agentTenantData?: any;
  setDetail?: (updater: (prev: any) => any) => void;
  onRefresh?: () => void;
}> = ({
  detail,
  drawerData,
  tenantId,
  configSwitch,
  // isSemirModel
  getPDFStatus,
  pdfDataStatus,
  rangeSelectValue, // 默认是围栏内，也可以是radius数字
  shareId,
  waterText = '',
  uploadPipelineStatus,
  getUploadPipelineStatus,
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI,
  agentTenantData,
  setDetail,
  onRefresh,
}) => {
  const { tenantInfo: {
    globalAliasItemVOs,
    standardChancePointReportLogo: reportLogo,
    id: targetTenantId, // 非分享页时
  },
  id: employeeId, // 非分享页时
  } = useContext(UserInfoContext); // 租户信息
  const { tenantCheckInfo } = useTenantCheckInfo({ immediate: !shareId }); // 租户信息;
  const isALQ = !!tenantCheckInfo?.isALQ;
  const intervalRef: any = useRef();
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [isPipelineUploading, setIsPipelineUploading] = useState<boolean>(uploadPipelineStatus === 1);
  const [progress, setProgress] = useState<number>(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const targetInputRef: any = useRef();
  const address = useMemo(() => {
    const {
      centerAddress,
      provinceName,
      cityName,
      districtName
    } = detail || {};
    let str = '';
    if (provinceName && provinceName !== cityName) {
      str += provinceName;
    }
    if (cityName) str += cityName;
    if (districtName) str += districtName;
    if (centerAddress) str += centerAddress;
    return str;
  }, [detail]);
  const showDownloadBtn = useMemo(() => { // 显示下载报告按钮
    const { exportStatus, name, url } = pdfDataStatus || {};
    return exportStatus === 2 && name && url;
  }, [pdfDataStatus]);
  // 是否展示AI解读分析按钮
  const showAIButton = useMemo(() => {
    return !!agentTenantData;
  }, [agentTenantData]);
  const { name: menuName } = usePageTitle('/spotevaluation');
  const curPath = window?.location?.pathname;

  // 模式名:半径/步行/骑行/驾车
  const searchTypeName = useMemo(() => {
    if (!isNotEmptyAny(detail)) return '';
    return getSearchTypeNameByValue(detail?.poiSearchType) || '';
  }, [detail]);

  // 模式名（标题显示用：不显示文案“半径”）:''/步行/骑行/驾车。只在街边店显示，商场店不显示
  const titleSearchTypeName = useMemo(() => {
    if (!isNotEmptyAny(detail)) return '';
    return getTitleSearchTypeNameByValue(detail?.poiSearchType) || '';
  }, [detail]);

  // 范围选中:1km/20分钟。只在街边店显示，商场店不显示
  const searchRadiusName = useMemo(() => {
    if (!isNotEmptyAny(detail)) return '';
    const res = getRadiusNameBySearchTypeAndValue({ searchType: detail?.poiSearchType, radius: detail?.radius, minute: detail?.poiSearchMinute, distance: detail?.poiSearchDistance, rangeMode: detail?.rangeMode });
    return res;
  }, [detail?.poiSearchType, detail?.radius, detail?.poiSearchMinute, detail?.poiSearchDistance, detail?.rangeMode]);

  const methods = useMethods({

    handleUploadPipeline: async () => {
      await uploadPipeline({
        id: drawerData.id,
      }).then(() => {
        setIsPipelineUploading(true);
        getUploadPipelineStatus && getUploadPipelineStatus();
      });
    },


    /** 获取分享用的公共参数 */
    getShareParams() {
      const currentTenantId = getCookie('tenantId') || targetTenantId;
      const userId = getCookie('employeeId') || employeeId;
      const { lng, lat, cityId, cityName, poiName, type, modelClusterId, modelConfigId } = drawerData;
      return {
        longLinkUrl: `${process.env.CONSOLE_PC_URL}/spotevaluation/detail`,
        // 参数和 exportPDF 统一
        content: JSON.stringify({
          lng,
          lat,
          cityId,
          cityName,
          poiName,
          type,
          modelClusterId,
          modelConfigId,
          tenantId: currentTenantId,
          globalAliasItemVOs,
          reportLogo,
          configSwitch,
          userId,
          // isSemirModel
          poiSearchType: detail.poiSearchType,
          radius: detail.radius,
          poiSearchMinute: detail.poiSearchMinute,
          poiSearchDistance: detail.poiSearchDistance,
          points: detail.points,
          waterText,
          isALQ,
          // 保留机会点周边信息来源；独立测评分享不启用。
          ...(drawerData.noDataPermission === true ? { noDataPermission: true } : {}),
          id: drawerData.id
        }),
      };
    },

    onShare() {
      const { cityName, poiName, type } = drawerData;
      const params = methods.getShareParams();
      getShareId(params).then((res: any) => {
        const op_event = type === SpotTypeEnum.Street ? `${cityName}_${poiName}_${searchTypeName}_${searchRadiusName}` : `${cityName}_${poiName}`;
        // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
        bigdataAction('6c139683-db67-474d-ae67-4ca368cbd261', 'spotEvaluation',
          '点位测评', '点位测评详情页-分享', '点击了点位测评详情页-分享', { op_block: '', op_event: op_event, });
        V2Message.success('链接已复制，可直接发送给你的朋友');
        // copy(res.frontShareLinkUrl);
        // https://gitlab.lanhanba.com/fe/treasure/-/issues/102
        setTimeout(() => {
          copy(`${detail.areaName}：${res.frontShareLinkUrl}`);
        }, 0);
      });
    },
    exportPDF: async () => {
      const tenantId = getCookie('tenantId') || targetTenantId;
      const _employeeId = getCookie('employeeId') || employeeId;
      const { cityName, poiName, type, modelConfigId } = drawerData;

      setIsExporting(true);
      intervalRef.current = setInterval(() => {
        if (progress === 99) {
          intervalRef.current && clearInterval(intervalRef.current);
          return;
        }
        setProgress((state) => {
          if (state < 95) return state + 5;
          return 99;
        });
      }, 600);
      let targetModelConfigId = modelConfigId;
      if (!targetModelConfigId || +targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = data[0]?.id || 0;
      }
      // 兜底，防止机会点所属商圈组件在引用该详情时，没有配置选址地图模型
      if (!targetModelConfigId) {
        V2Message.warning(`请先配置选址地图模型！`);
        return;
      }
      /**
       * 导出的 pdf 页面为：
       * drawerData.type === 1，街边店：src/views/pdf/pages/streetareareport/entry.tsx
       * drawerData.type === 2，商场店：src/views/pdf/pages/areareport/entry.tsx
       */
      getShareId({
        ...methods.getShareParams(),
        expirationDate: null, // 代表永不失效
        expirationRedirectUrl: `${process.env.CONSOLE_PC_URL}/share/failure`,
        needToken: true,
      }).then(async (res: any) => {
        const shareUrl = res.frontShareLinkUrl;
        const routePath = drawerData.type === 1 ? 'streetareareport' : 'areareport';
        const commonQuery = {
          tenantId: tenantId,
          modelConfigId: targetModelConfigId,
          employeeId: _employeeId,
          shareUrl: shareUrl,
        };
        const commonQueryStr = queryObjectToString(commonQuery, { encode: false }); // 因为以前没转码，所以这里也不转码
        let url: string[] = [
          `${process.env.CONSOLE_PC_URL}/pdf/${routePath}?moduleName=${AreaReportModule.MODULE_1}&${commonQueryStr}&`,
          `${process.env.CONSOLE_PC_URL}/pdf/${routePath}?moduleName=${AreaReportModule.MODULE_2}&${commonQueryStr}&`,
          `${process.env.CONSOLE_PC_URL}/pdf/${routePath}?moduleName=${AreaReportModule.MODULE_3}&${commonQueryStr}&`,
        ];
        if (drawerData.type === 1) { // 街边店类型追加入参
          const moreQuery: string[] = []; // 街边店类型
          moreQuery.push(`rangeValue=500`); // 好像没有用
          moreQuery.push(`treeLng=${drawerData.lng}`);
          moreQuery.push(`treeLat=${drawerData.lat}`);
          moreQuery.push(`treePoiName=${encodeURIComponent(drawerData.poiName)}`);
          moreQuery.push(`treeRadius=${detail.radius}`);
          moreQuery.push(`evaluationRecordId=${drawerData.id}`);
          url = url.map(item => item + moreQuery.join('&'));
        } else {
          const moreQuery: string[] = []; // 商场店类型
          moreQuery.push(`rangeValue=${rangeSelectValue}`);
          moreQuery.push(`id=${drawerData.modelClusterId}`);
          moreQuery.push(`mapDataType=youthMapData`); // pdf内容一部分请求使用青春版接口（周边配套poi等）
          moreQuery.push(`isSpotevaluationShop=1`); // 标记点位测评商场店
          url = url.map(item => item + moreQuery.join('&'));
        }
        const op_event = type === SpotTypeEnum.Street ? `${cityName}_${poiName}_${searchTypeName}_${searchRadiusName}` : `${cityName}_${poiName}`;
        bigdataAction('6c36427c-73d6-4017-a8df-65fd31246eb2', 'spotEvaluation',
          '点位测评', '点位测评详情页-导出', '点击了点位测评详情页-导出', { op_block: '', op_event: op_event, });
        const params = {
          name: `${drawerData.poiName || '点位测评报告'}.pdf`,
          type: 3, // 导出类型：1:商圈 2:机会点 3:点位测评
          id: drawerData.id,
          menuName: curPath === '/spotevaluation' ? menuName : `${menuName}-查询历史`,
          nodeData: {
            name: `${drawerData.poiName || '点位测评报告'}.pdf`,
            options: [
              { // 定制化模块，并合并至最终的pdf里
                url,
                containerClass: ARE_AREPORT_CONTAINER_CLASS,
                childClass: ChildreClass,
              }
            ],
            waterMark: waterText,
            needPageTable: true,
          },
        };
        // 接口异步下载
        await exportModelClusterPDFAsync(params).finally(() => {
          V2Message.success('报告正在生成中，请稍后查看');
          // 轮训状态
          getPDFStatus && getPDFStatus();
        });
      });
    },
    handleDownload: () => {
      const { name, url } = pdfDataStatus;
      downloadFile({
        name,
        url: `${process.env.STATIC_RES_DOMAIN}//libs/preview-pdf/web/viewer.html?file=${encodeURIComponent(url)}&fixname=` + encodeURIComponent(`${name}`)
      });
    },
    /**
     * 编辑标题
     */
    handleEditTitle() {
      setModalVisible(true);
      form.setFieldValue('title', detail.title);
      setTimeout(() => {
        // https://4x-ant-design.antgroup.com/components/input-cn/
        targetInputRef.current!.focus({
          cursor: 'end',
        });
      }, 100);
    },
    /**
     * 标题编辑弹窗确认
     */
    async handleModalOk() {
      try {
        const values = await form.validateFields();
        await editEvaluationTitle({
          id: drawerData.id,
          title: values.title,
        });
        // 接口成功后局部更新 detail.title，避免重新请求详情接口
        setDetail?.((prev: any) => ({
          ...prev,
          title: values.title,
        }));
        setModalVisible(false);
        onRefresh && onRefresh();
        V2Message.success('标题修改成功');
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 标题编辑弹窗取消
     */
    handleModalCancel() {
      setModalVisible(false);
      form.resetFields();
    }
  });

  useEffect(() => {
    const { exportStatus } = pdfDataStatus || {};
    if (exportStatus === 3) {
      setIsExporting(true);
      if (intervalRef.current) return; // 如果还未创建定时器说明是第一次进来
      setProgress(99);
    } else {
      setIsExporting(false);
      setProgress(0);
      if (!intervalRef.current) return;
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [pdfDataStatus]);

  useEffect(() => {
    setIsPipelineUploading(uploadPipelineStatus === 1);
  }, [uploadPipelineStatus]);

  return (<>
    <div className={cs(styles.topCon, tenantId && styles.isShare)}>
      <div className={styles.titleRow}>
        <Text
          style={{ width: '100%' }}
          ellipsis={{ tooltip: drawerData.type === SpotTypeEnum.Street && detail.title ? detail.title : detail.areaName }}>
          <span className={styles.title}>
            { drawerData.type === SpotTypeEnum.Street ? '街边店 - ' : '商场店 - ' }
            { drawerData.type === SpotTypeEnum.Street && (titleSearchTypeName || searchRadiusName) ? `${titleSearchTypeName}${searchRadiusName} - ` : '' }
            { // 街边店时可自定义标题
              drawerData.type === SpotTypeEnum.Street ? <>
                {
                  detail.title ? <>
                    <span className='pr-2'>{detail.title}</span>
                    {
                      !shareId && <span>
                        <IconFont
                          iconHref='pc-common-icon-ic_edit'
                          className='fs-18 pointer'
                          onClick={methods.handleEditTitle}
                        />
                      </span>
                    }
                  </> : <>{detail.areaName}</>
                }
              </> : <>{detail.areaName}</>
            }
          </span>
        </Text>
        { !!detail.centerAddress && (
          <Text
            style={{ width: '100%' }}
            ellipsis={{ tooltip: address }}>
            <div className={styles.subTitle}>
              <IconFont iconHref='iconIC_dizhi' className={styles.subTitleIcon} />
              { address }
            </div>
          </Text>
        ) }
      </div>
      {isALQ && !shareId && (
        <Button
          loading={isPipelineUploading}
          className='inline-block mr-8'
          onClick={methods.handleUploadPipeline}
          disabled={isPipelineUploading}
        >
                上传pipeline
        </Button>
      )}

      {/* 分享页显示logo，非分享页显示分享按钮 */}
      { tenantId ? (
        <ReportLogo
          tenantId={tenantId}
          tenantLogo={drawerData.reportLogo}
          className='pt-3'
        />
      ) : (
        <div className={styles.flexCon}>
          <Button
            className='inline-block mr-8'
            onClick={methods.onShare}
          >
              分享
          </Button>
        </div>
      ) }
      {
        !shareId && (
          <>
            {
              showDownloadBtn
                ? <Button
                  onClick={methods.handleDownload}
                  className='ml-8'
                >
                    查看报告
                </Button> : <></>
            }
            <Button
              loading={isExporting}
              onClick={methods.exportPDF}
              disabled={pdfDataStatus?.exportStatus === 3}
              // 当存在集客点录入按钮时，集客点为primary，其余为default
              type='primary'
              className='inline-block ml-8'
            >
              {isExporting ? '正在' : ''}导出报告
            </Button>
            {/* 按钮展示的判断逻辑 */}
            {
              showAIButton && <div
                className={cs(styles.AICon, isStartAnalyseOfAI ? styles.isDisabled : '')}
                onClick={() => {
                  if (isStartAnalyseOfAI) return;
                  setIsStartAnalyseOfAI && setIsStartAnalyseOfAI(true);
                }}
              >
                <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/ai/icon_ai_button@2x.png`}
                  width='100%'
                  height='100%'
                />
              </div>
            }
          </>
        )
      }
    </div>
    <Modal
      title='编辑名称'
      open={modalVisible}
      onOk={methods.handleModalOk}
      onCancel={methods.handleModalCancel}
      destroyOnClose
    >
      <V2Form form={form}>
        <V2FormInput
          label='名称'
          name='title'
          required
          maxLength={30}
          rules={[{ required: true, message: '请输入测评标题' }]}
          config={{ ref: targetInputRef }}
        />
      </V2Form>
    </Modal>
  </>
  );
};

export default Top;
